import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "../ui/dialog";
import { PollMarkdownContent } from "./poll-markdown-content";

// Option-note viewer. Migrated to the Radix Dialog primitive so it stacks
// correctly as a NESTED dialog over the poll modal (focus trap, Escape closes
// the inner dialog first, click-outside closes only the note — never the
// parent poll). When `noteViewer` is null the dialog is closed (renders nothing).
export function PollOptionNoteDialog({ noteViewer, onClose }) {
  const label = noteViewer?.optionLabel || "Option";
  return (
    <Dialog open={Boolean(noteViewer)} onOpenChange={(open) => { if (!open) onClose?.(); }}>
      <DialogContent
        showCloseButton={false}
        aria-describedby={undefined}
        className="max-w-2xl"
      >
        <div className="mb-3 flex items-center justify-between gap-2">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400">
              {noteViewer?.pollTitle || "General poll"}
            </p>
            <DialogTitle className="text-base font-semibold text-slate-900 dark:text-slate-100">
              Option note for {label}
            </DialogTitle>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-slate-300 px-2 py-1 text-xs text-slate-600 dark:border-slate-600 dark:text-slate-300"
          >
            Close
          </button>
        </div>
        <PollMarkdownContent
          content={noteViewer?.note}
          className="max-h-[65vh] overflow-auto rounded-lg border border-slate-200 bg-white px-3 py-2 dark:border-slate-700 dark:bg-slate-900"
        />
      </DialogContent>
    </Dialog>
  );
}
